module.exports = __webpack_public_path__ + "static/media/Golos_Text_Medium.9d44b0fb.woff2";